import styled from 'styled-components';

import { ThemeMode } from '@/helpers/enums';

import { hexToRGB } from '@/styles/helpers';

export type ScrollBlockStyleProps = {
  height?: string;
  width?: string;
  mode?: ThemeMode;
  scrollTopMargin?: number;
  scrollBottomMargin?: number;
};

export const ScScrollBlock = styled.div<ScrollBlockStyleProps>`
  height: ${({ height }) => height || '100%'};
  width: ${({ width }) => width || 'calc(100% + 8px)'};
  padding-right: 8px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 4px !important;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-thumb {
    cursor: pointer;
    border-radius: 20px;
    background-color: ${({ theme, mode }) =>
      mode === ThemeMode.Dark
        ? hexToRGB(theme.whiteColor, 0.2)
        : hexToRGB(theme.blackColor, 0.2)} !important;

    @media (hover: hover) {
      &:hover {
        background-color: ${({ theme, mode }) =>
          mode === ThemeMode.Dark
            ? theme.whiteColor
            : theme.blackColor} !important;
      }
    }
  }

  &::-webkit-scrollbar-track {
    margin-top: ${({ scrollTopMargin }) => `${scrollTopMargin}px`};
    margin-bottom: ${({ scrollBottomMargin }) => `${scrollBottomMargin}px`};
  }
`;
